import CloudOffIcon from '@mui/icons-material/CloudOff'
import PersonAddIcon from '@mui/icons-material/PersonAdd'
import SyncIcon from '@mui/icons-material/Sync'
import StorageIcon from '@mui/icons-material/Storage'

import PatientsIcon from '@/components/ui/icons/Patients'
import ConsultationIcon from '@/components/ui/icons/Consultation'

export type OfflineSidebarItem = {
    name: string
    label: string
    link: string
    icon: React.ComponentType
    isPathBase?: boolean
}

export const offlineSidebarItems: OfflineSidebarItem[] = [
    {
        name: 'offline-patients',
        label: 'Offline Patients',
        link: '/offline/patients',
        icon: PatientsIcon,
        isPathBase: true,
    },
    {
        name: 'create-offline-patient',
        label: 'Create Patient',
        link: '/offline/patients/create',
        icon: PersonAddIcon,
    },
    {
        name: 'offline-consultations',
        label: 'Offline Consultations',
        link: '/offline/consultations',
        icon: ConsultationIcon,
        isPathBase: true,
    },
    {
        name: 'sync-status',
        label: 'Sync Status',
        link: '/offline/sync',
        icon: SyncIcon,
    },
] 